export const FulfillmentType = Object.freeze({
  DIGITAL: 'DIGITAL',
  MOBILE: 'MOBILE',
  PHYSICAL: 'PHYSICAL',
  BULK_PHYSICAL: 'BULK_PROVISIONING_SUPPORTED'
})
